import * as React from 'react';

import { Text } from '@ekhodealer/ekho-common/rev';

export interface TextWithLeadingIconCellProps {
	/** The text to display */
	text: string;
	/** Optional icon component to display on the left */
	icon?: React.ReactNode;
	/** Optional minimum width for the cell */
	minWidth?: string;
}

/**
 * Shared component for displaying text with an optional leading icon in table cells.
 * Used by PaymentChoiceCell, TypeCell, and other table cells that need icon + text layout.
 */
export const TextWithLeadingIconCell = ({
	text,
	icon,
	minWidth = '120px',
}: TextWithLeadingIconCellProps) => {
	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				gap: '6px',
				minWidth,
			}}>
			{icon && icon}
			<Text size='bodySmall'>{text}</Text>
		</div>
	);
};
